export default "__VITE_ASSET__Dn5bH2oH__"